import React from "react"

const Cart = (props) => {
  return (
    <div>
      
    </div>
  )
};

export default Cart;
